import { render, staticRenderFns } from "./CapituloDocePage.vue?vue&type=template&id=8b6781f4"
import script from "./CapituloDocePage.js?vue&type=script&lang=js&external"
export * from "./CapituloDocePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports